import React from "react";
import uuid from "react-uuid";
import pherologo from "../images/ph_logo.cda7f338.svg";

const Courses = () => {
  const courses = [
    {
      course: "Complete Web Development",
      institute: "Programming Hero",
      year: "1 July, 2021 - 20 November, 2021",
      logo: pherologo,
      website: "https://web.programming-hero.com/",
    },
    // {
    //   course: "Redux From Beginner Level To Advanced",
    //   institute: "Programming Hero",
    //   year: "December 2022",
    //   logo: pherologo,
    //   website: "https://web.programming-hero.com/",
    // },
  ];
  return (
    <div className="courses">
      <div className="section-heading">
        <h4>Courses</h4>
      </div>
      <div className="companies">
        {courses.map((course) => (
          <div key={uuid()} className="company-position">
            <div className="company-logo">
              <a href={course.website}>
                {" "}
                <img src={course.logo} alt="" />
              </a>
            </div>
            <div className="employee-details">
              <h5>{course.course}</h5>
              <p>{course.institute}</p>
              <h6>{course.year}</h6>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Courses;
